const styles = (theme) => ({
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    listItemText: {
        color: 'white',
        fontSize: '.9rem',
    },
    listItemIcon: {
        color: 'white',
    },
});

export default styles;
